module.exports = __webpack_public_path__ + "img/result_graphics.729535bd.png";